import { Toolbar } from 'components/List'
import React, { FC } from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  SelectInput,
  ReferenceInput,
  ListProps,
} from 'react-admin'

// import { Filters } from './containers/Filters'

export const ListPopups: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List
      {...rest}
      data-testid="list"
    >
      <Datagrid rowClick={'edit'}>
        <TextField label="#" source="id" />
        <TextField label="Nome" source="title" />
        <TextField label="Tipo" source="type" />
        <TextField label="Slug" source="slug" />
        <TextField label="Texto" source="description" />
        <TextField label="Status" source="status" />
      </Datagrid>
    </List>
  )
}
